import { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.min.css';
import { Phone, Mail, MapPin, Send, MessageCircle } from 'lucide-react';
import './Contact.css';

export default function Contact() {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    const name    = e.target.querySelector('[name="user_name"]').value;
    const phone   = e.target.querySelector('[name="user_phone"]').value;
    const message = e.target.querySelector('[name="message"]').value;
    const fmt = (d) => d ? d.toLocaleDateString('sq-AL') : '—';
    const text = `Pershendetje! 👋\n\nEmri: ${name}\nTelefoni: ${phone}\nData e Marrjes: ${fmt(startDate)}\nData e Kthimit: ${fmt(endDate)}${message ? `\nMesazhi: ${message}` : ''}\n\nDua te rezervoj nje makine me Rremi Rent a Car.`;
    window.open(`https://wa.me/38343888408?text=${encodeURIComponent(text)}`, '_blank');
  };

  return (
    <section id="contact" className="contact">

      {/* Background layers */}
      <div className="contact__bg" />
      <div className="contact__bg-glow contact__bg-glow--1" />
      <div className="contact__bg-glow contact__bg-glow--2" />

      <div className="container contact__inner">

        {/* Left info */}
        <div className="contact__info">
          <span className="contact__eyebrow">Kontakti</span>
          <h2 className="contact__title">
            Rezervo<br />
            <em>Makinën</em><br />
            Tani
          </h2>
          <p className="contact__sub">
            Plotëso formularin dhe do të të kontaktojmë
            menjëherë nëpërmjet WhatsApp.
          </p>

          <div className="contact__details">
            <a href="tel:+38343888408" className="contact__detail">
              <div className="contact__detail-icon">
                <Phone size={15} />
              </div>
              <div>
                <span>Telefon</span>
                <strong>+383 43 888 408</strong>
              </div>
            </a>
            <a href="mailto:rremirentacar@gmail.com" className="contact__detail">
              <div className="contact__detail-icon">
                <Mail size={15} />
              </div>
              <div>
                <span>Email</span>
                <strong>rremirentacar@gmail.com</strong>
              </div>
            </a>
            <div className="contact__detail">
              <div className="contact__detail-icon">
                <MapPin size={15} />
              </div>
              <div>
                <span>Adresa</span>
                <strong>Prishtinë, Kosovë</strong>
              </div>
            </div>
          </div>
        </div>

        {/* Right form */}
        <div className="contact__form-card">
          <div className="contact__form-header">
            <MessageCircle size={18} />
            <span>Dërgo Kërkesën</span>
          </div>

          <form className="contact__form" onSubmit={handleSubmit}>
            <div className="contact__field">
              <label>Emri & Mbiemri</label>
              <input
                type="text"
                name="user_name"
                placeholder="Agim Krasniqi"
                required
              />
            </div>

            <div className="contact__field">
              <label>Numri i Telefonit</label>
              <input
                type="tel"
                name="user_phone"
                placeholder="+383 44 ..."
                required
              />
            </div>

            <div className="contact__dates">
              <div className="contact__field">
                <label>Data e Marrjes</label>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  minDate={new Date()}
                  placeholderText="Zgjidh datën"
                  dateFormat="dd/MM/yyyy"
                  className="contact__datepicker"
                  required
                />
              </div>
              <div className="contact__field">
                <label>Data e Kthimit</label>
                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  minDate={startDate || new Date()}
                  placeholderText="Zgjidh datën"
                  dateFormat="dd/MM/yyyy"
                  className="contact__datepicker"
                  required
                />
              </div>
            </div>

            <div className="contact__field">
              <label>
                Mesazhi
                <span className="contact__optional">(opsional)</span>
              </label>
              <textarea
                name="message"
                rows={3}
                placeholder="Çfarë makine po kërkoni?"
              />
            </div>

            <button type="submit" className="contact__submit">
              <Send size={14} />
              Dërgo në WhatsApp
            </button>
          </form>
        </div>

      </div>
    </section>
  );
}